import React from "react";
import { Box, CircularProgress } from "@mui/material";
import replyIcon from "../../../assets/images/chats/reply.svg";
import { getFileIconUrl } from "../../../utils/findextension";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { colorSchemes } from "../../../assets/commonFunction";

const SelectedAttachmentAiQuery = ({
  data,
  handleRemoveAttachment,
  replyParentMsg = "",
  isUploading = false,
}) => {
  return (
    <Box
      position={"absolute"}
      //bgcolor={"#FBFBFB"}
      display={"flex"}
      boxSizing={"border-box"}
      width={"100%"}
    >
      {data?.map((item, i) => (
        <Box
          display={"flex"}
          maxWidth={"25%"}
          padding={"0.5rem"}
          key={"fileAttachment" + i}
        >
          <Box width={"100%"}>
            {isUploading ? (
              <CircularProgress size={20}  sx={{ color: colorSchemes.themeRedColor,height:30 }} />
            ) : (
            <Chip
              sx={{}}
              label={`${item?.name ? item?.name : item?.file?.name}`}
              variant="outlined"
              avatar={
                <Avatar
                  alt="Natacha"
                  src={
                    replyParentMsg
                      ? replyIcon
                      : getFileIconUrl(
                          item?.name ? item?.location : item?.file?.name
                        )
                  }
                  title={`${item?.name ? item?.name : item?.file?.name}`}
                />
              }
            />
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SelectedAttachmentAiQuery;
